import { useNotification } from 'admin';
import { useApiAccountsV1SigninVerifyCreate } from 'api';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { OtpForm, type OtpFormValues } from '../../components/OtpForm/OtpForm';
import { OtpIcon } from '../../components/OtpIcon/OtpIcon';
import { SignInPage } from '../../components/SignInPage/SignInPage';
import { getAuthRoute } from '../../utils/getAuthRoute';
import { redirectPostSignIn } from '../../utils/redirectPostSignIn';

export const SignInPhoneVerify = () => {
  const { open } = useNotification();
  const { mutate, isPending } = useApiAccountsV1SigninVerifyCreate({
    mutation: {
      onError() {
        open?.({
          message: 'Error verifying passcode',
          type: 'error',
        });
      },
      onSuccess() {
        redirectPostSignIn();
      },
    },
  });

  const handleSubmit = (data: OtpFormValues) => {
    mutate({
      data: {
        verification_code: data.email_verification_code,
      },
    });
  };

  return (
    <SignInPage>
      <OtpIcon variant="phone" />
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Welcome back!
      </Typography>
      <Typography>Check your phone. We&apos;ve sent a one-time passcode to sign in to Safi.</Typography>
      <OtpForm onSubmit={handleSubmit} isLoading={isPending} />
      <Link component={RouterLink} to={getAuthRoute('/sign-in/phone')}>
        Go back
      </Link>
    </SignInPage>
  );
};
